/* Tysk katalog for locale-no.js (del 2 av 10).
 * Nøkler som mangler her, vises på engelsk. */
window.PlummeI18n.register('de', {
  'fi.recheck': 'Ich habe bestätigt',
  'fi.stillUnverified': 'Die Adresse ist noch nicht bestätigt. Prüfe den Posteingang und den Spam-Ordner.',
  'fi.decline': 'Ablehnen',
  'fi.declined': 'Die Einladung wurde abgelehnt.',
  'set.firm.title': 'Buchhaltungsbüro',
  'set.firm.sub': 'Das Büro erhält erst Zugang zur Buchhaltung, wenn du zustimmst, und verliert ihn, sobald du die Zusammenarbeit beendest.',
  'set.firm.none': 'Kein Buchhaltungsbüro hat Zugang zu diesem Unternehmen, und keines hat darum gebeten.',
  'set.firm.pending': 'Wartet auf deine Antwort',
  'set.firm.active': 'Hat Zugang',
  'set.firm.end': 'Zusammenarbeit beenden',
  'set.firm.endConfirm': 'Zusammenarbeit mit {firm} beenden? Die Mitarbeiter verlieren sofort den Zugang zur Buchhaltung.',
  'set.firm.ended': 'Die Zusammenarbeit ist beendet, und der Zugang wurde entzogen.',
  'set.firm.onlyManagers': 'Nur Eigentümer und Administratoren können auf eine Anfrage antworten.',
  'rf.create.title': 'Buchhaltungsbüro erstellen',
  'rf.create.eyebrow': 'Buchhaltungsbüro',
  'rf.create.readyBody': 'Das Büro ist erstellt, und du bist Eigentümer. Als Nächstes lädst du deine Mitarbeiter ein und verknüpfst Mandanten.',
  'rf.create.openSurface': 'Büroansicht öffnen',
  'rf.create.body': 'Das Büro wird aus dem Enhetsregisteret abgerufen. Du wirst Eigentümer und kannst danach Mitarbeiter einladen.',
  'rf.create.orgNumber': 'Organisationsnummer',
  'rf.create.hintDigits': 'Neun Ziffern. Das Büro muss im Enhetsregisteret eingetragen sein.',
  'rf.create.hintReady': 'Die Nummer wird beim Erstellen im Enhetsregisteret abgefragt.',
  'rf.create.hintDemo': 'Das Demokonto kann eine erfundene Nummer verwenden. Gib dem Büro unten einen Namen.',
  'rf.create.firmName': 'Name des Büros',
  'rf.create.nameRequired': 'Das Unternehmen wurde im Enhetsregisteret nicht gefunden. Gib den Namen des Büros ein, um fortzufahren.',
  'rf.create.unverifiedNote': 'Das Büro wird ohne Registerabfrage erstellt und als unverifiziert markiert. Es muss verifiziert werden, bevor echte Büros in Betrieb gehen.',
  'rf.create.demoNote': 'Beim Demokonto wird der Name selbst festgelegt. Normale Konten erhalten den Namen aus dem Enhetsregisteret.',
  'rf.create.submit': 'Büro erstellen',
  'rf.create.working': 'Wird erstellt …',
  'rf.create.done': 'Das Buchhaltungsbüro wurde erstellt',
  'rf.create.note': 'Die Abfrage bestätigt, dass das Unternehmen existiert. Sie prüft nicht, ob du in seinem Namen handeln darfst.',
  'rf.member.title': 'Position',
  'rf.member.email': 'E-Mail',
  'rf.member.person': 'Person',
  'rf.member.rights': 'Rechte',
  'rf.member.inviteTitle': 'Mitarbeiter einladen',
  'rf.member.invite': 'Einladung senden',
  'rf.member.inviting': 'Wird gesendet …',
  'rf.member.invited': 'Einladung gesendet',
  'rf.member.inviteMailFailed': 'Die Einladung wurde erstellt, aber die E-Mail konnte nicht gesendet werden.',
  'rf.member.listTitle': 'Mitarbeiter',
  'rf.member.none': 'Noch keine Mitarbeiter.',
  'rf.member.updated': 'Die Position wurde geändert',
  'rf.member.remove': 'Zugang entfernen',
  'rf.member.removed': 'Der Zugang wurde entfernt',
  'rf.member.removedWithClients': 'Der Zugang wurde entfernt, auch bei {count} Mandanten.',
  'rf.member.removeConfirm': 'Zugang für {name} entfernen? Alle Mandantenzugänge, die das Büro dieser Person gewährt hat, werden gleichzeitig entzogen.',
  'rf.member.removeNote': 'Wenn du einen Mitarbeiter entfernst, werden auch alle Mandantenzugänge entzogen, die das Büro der Person gewährt hat — bei allen Mandanten, in einem Vorgang.',
  'rf.member.ownerRights': 'Eigentümer des Büros',
  'rf.member.canControl': 'Darf kontrollieren',
  'rf.nav.backToApp': 'Zu meiner Buchhaltung',
  'rf.nav.back': 'Zurück',
  'app.nobusiness.openFirm': 'Buchhaltungsbüro öffnen',
  'rf.tab.close': 'Tab schließen',
  'rf.tab.assignFirst': 'Für diesen Mandanten ist noch niemand dem Auftrag zugewiesen. Der Zugang zur Buchhaltung folgt der Zuweisung — weise unter Mandanten jemanden dem Auftrag zu.',
  'rf.tab.assignNeeded': 'Du bist diesem Mandantenauftrag nicht zugewiesen. Bitte einen Administrator im Büro, dich zuzuweisen.',
  'rf.soon.clients': 'Die Mandantenübersicht wird jetzt mit dem Mandantenstatus verbunden, den das Backend für jeden Mandanten berechnet.',
  'rf.soon.reconciliation': 'Die Abstimmungsansicht wird gerade gebaut. Das Zugriffsmodell und der Mandantenstatus, auf denen sie aufbaut, sind vorhanden.',
  'rf.soon.control': 'Die Kontrollansicht folgt nach der Abstimmung. Das Vier-Augen-Prinzip wird beim Start im Backend durchgesetzt.',
  'rf.noFirm.title': 'Du bist kein Mitglied eines Buchhaltungsbüros',
  'rf.noFirm.body': 'Du bist noch kein Mitglied eines Büros. Erstelle unten dein eigenes oder bitte einen Administrator im Büro, dich einzuladen — die Einladung kommt per E-Mail.',
  'tc.title': 'Teamchat',
  'tc.rooms': 'Räume',
  'tc.dms': 'Direktnachrichten',
  'tc.newRoom': 'Neuer Raum',
  'tc.roomName': 'Raumname',
  'tc.roomNamePlaceholder': 'Z. B. Kontroll-Team',
  'tc.createRoom': 'Raum erstellen',
  'tc.noColleagues': 'Noch keine anderen im Büro',
  'tc.commonRoom': 'Gemeinschaftsraum',
  'tc.room': 'Raum',
  'tc.commonSubtitle': 'Gemeinsamer Raum für das ganze Team',
  'tc.roomSubtitle': 'Raum im Büro',
  'tc.dm': 'Direktnachricht',
  'tc.dmSubtitle': 'Direktnachricht',
  'tc.empty': 'Hier gibt es noch keine Nachrichten — schreib die erste.',
  'tc.placeholder': 'Nachricht schreiben…',
  'tc.send': 'Senden',
  'tc.unknown': 'Unbekannt',
  'shell.client.clients': 'Deine Mandanten',
  'shell.client.signOutSub': 'Sitzung auf diesem Gerät beenden',
  'shell.client.signOutFailed': 'Abmelden fehlgeschlagen. Versuche es erneut.',
  'shell.client.none': 'Kein Unternehmen',
  'shell.client.noBusinesses': 'Keine Unternehmen',
  'shell.client.connecting': 'Verbindung zum Plumme-Backend wird hergestellt',
  'shell.client.personalEconomy': 'Privatfinanzen',
  'shell.client.accountingClient': 'Buchhaltungsmandant',
  'shell.client.org': 'Org. {org}',
  'shell.suggest.invoices': 'Rechnungen',
  'shell.suggest.customers': 'Kunden',
  'shell.suggest.vouchers': 'Belege',
  'trial.title': 'Testphase ist aktiv',
  'trial.active': 'Die Testphase ist aktiv.',
  'trial.dayLeft': 'Du hast noch {days} Tag.',
  'trial.daysLeft': 'Du hast noch {days} Tage.',
  'trial.body': 'Alles funktioniert - viel Spaß beim Kennenlernen von Plumme.',
  'trial.upgrade': 'Upgraden',
  'home.greeting': 'Willkommen zurück 👋',
  'home.registerSale': 'Verkauf erfassen',
  'home.registerSaleHelp': 'Erfasse einen neuen Verkauf oder erstelle eine Rechnung für einen Kunden. Der Verkauf wird automatisch auf das richtige Konto gebucht.',
  'home.registerPurchase': 'Einkauf erfassen',
  'home.registerPurchaseHelp': 'Erfasse einen Einkauf oder lade einen Beleg hoch. SuperPlumma schlägt dir Konto und MwSt.-Behandlung vor.',
  'home.aiHelp': 'Hier siehst du alles, was SuperPlumma und seine Agenten automatisch erledigt haben – Buchhaltung, MwSt., Lohn und mehr. Du genehmigst mit einem Tipp.',
  'home.autopilot.active': 'Aktiv',
  'home.autopilot.followUp': 'Muss nachverfolgt werden',
  'home.autopilot.disabled': 'Deaktiviert',
  'home.view.period': 'Zeitraum',
  'home.view.analysis': 'Analyse',
  'home.view.cashflow': 'Nettoergebnis',
  'home.viewLabel.period': 'Erträge und Aufwendungen pro Monat',
  'home.viewLabel.analysis': 'Verteilung Erträge vs. Aufwendungen',
  'home.viewLabel.cashflow': 'Nettoergebnis pro Monat',
  'home.ana.ring': 'Verteilung',
  'home.ana.gauge1': 'Kennzahlen',
  'home.ana.gauge2': 'Finanzkennzahlen',
  'home.sub.yoyArrow': 'Der Pfeil zeigt die Veränderung zum Vorjahr.',
  'home.sub.exVat': 'Alle Summen werden ohne MwSt. angezeigt.',
  'home.legend.in': 'Ein',
  'home.legend.out': 'Aus',
  'home.legend.income': 'Ertrag',
  'home.legend.cost': 'Aufwand',
  'home.legend.result': 'Ergebnis',
  'home.legend.cashflow': 'Ergebnis',
  'home.selectedMonths': 'Ausgewählte Monate:',
  'home.reset': 'Zurücksetzen',
  'home.sumOfMonth': 'Summe von {n} Monat',
  'home.sumOfMonths': 'Summe von {n} Monaten',
  'home.noPrevPeriod': 'Kein vorheriger Zeitraum',
  'home.fromPrevMonth': 'zum Vormonat',
  'home.fromLastYear': 'zum Vorjahr',
  'home.showDistribution': 'Verteilung anzeigen',
  'home.noData': 'Keine Daten',
  'home.donut.registeredIncome': 'Erfasste Erträge',
  'home.donut.registeredCosts': 'Erfasste Kosten',
  'home.donut.income': 'Erträge',
  'home.donut.costs': 'Kosten',
  'home.donut.result': 'Ergebnis',
  'home.donut.breakdown': '{title} — Aufteilung',
  'home.donut.back': 'Zurück',
  'home.donut.hint': 'Tippe auf einen Teil des Rings oder eine KPI-Karte unten, um die Aufteilung zu sehen',
  'home.health.good': 'Gut',
  'home.health.balanced': 'Ausgewogen',
  'home.health.weak': 'Schwach',
  'home.gauge.explain': 'Kennzahl erklären',
  'home.gauge.currentValue': 'Aktueller Wert',
  'home.gauge.assessment': 'Bewertung',
  'home.gauge.goodLevel': 'Gutes Niveau: {good}',
  'home.gauge.income': 'Erträge',
  'home.gauge.income.info': 'Erträge sind die Summe aller Verkäufe des Unternehmens im Zeitraum, ohne MwSt. Steigende Erträge über die Zeit verschaffen mehr Handlungsspielraum.',
  'home.gauge.income.good': 'Steigend über die Zeit',
  'home.gauge.costs': 'Kosten',
  'home.gauge.costs.info': 'Kosten sind die Ausgaben, die zum Betrieb des Unternehmens nötig sind, ohne MwSt. Niedrigere Kosten im Verhältnis zu den Erträgen ergeben ein besseres Ergebnis.',
  'home.gauge.costs.good': 'Niedriger als die Erträge',
  'home.gauge.result': 'Ergebnis',
  'home.gauge.result.info': 'Das Ergebnis ist das, was übrig bleibt, wenn die Kosten von den Erträgen abgezogen werden. Ein positives Ergebnis bedeutet einen Gewinn im Zeitraum.',
  'home.gauge.result.good': 'Positiv und stabil',
  'home.gauge.liquidity': 'Liquidität',
  'home.gauge.liquidity.info': 'Die Liquidität zeigt die Fähigkeit, Rechnungen und kurzfristige Verbindlichkeiten bei Fälligkeit zu bezahlen. Ein höherer Wert bietet einen besseren Puffer.',
  'home.gauge.liquidity.good': 'Über 1,0x, am besten über 2,0x',
  'home.gauge.profitability': 'Rentabilität',
  'home.gauge.profitability.info': 'Die Rentabilität zeigt, welcher Anteil der Erträge als Ergebnis übrig bleibt. Je höher der Prozentsatz, desto mehr verdient das Unternehmen pro verkaufter Krone.',
  'home.gauge.profitability.good': 'Positiv und steigend',
  'home.gauge.solidity': 'Solidität',
  'home.gauge.solidity.info': 'Die Solidität zeigt, welcher Teil des Unternehmens mit Eigenkapital finanziert ist. Höhere Solidität macht das Unternehmen robuster.',
  'home.gauge.solidity.good': 'Höhere Eigenkapitalquote über die Zeit',
  'home.assistant.sub': 'Buchhaltungsassistent',
  'home.assistant.intro': 'Hallo! Ich kann einfache Aktionen für dich erledigen, Rechnungen erstellen, Einkäufe erfassen, Abgaben erklären und Belege aus dem Posteingang buchen. Frag einfach. Wenn du eine Finanzberatung möchtest, ist der Berater auf der Seite AI Berater verfügbar.',
  'home.assistant.thinking': 'SuperPlumma denkt nach...',
  'home.assistant.placeholder': 'Frag SuperPlumma...',
  'home.assistant.noReply': 'SuperPlumma hat keine Antwort vom Backend erhalten.',
  'home.assistant.errorReply': 'Die Antwort des Assistenten konnte gerade nicht abgerufen werden.',
  'home.assistant.errorToast': 'Assistentenantwort konnte nicht abgerufen werden.',
  'home.assistant.cancel': 'Abbrechen',
  'home.assistant.opened': 'Ich habe die richtige Seite mit dem Vorschlag zur Prüfung geöffnet.',
  'home.assistant.openedToast': 'Richtigen Ablauf geöffnet',
  'home.assistant.noAdapter': 'Für diese Aktion gibt es noch keinen Plumme-Adapter.',
  'home.assistant.paymentNotConnected': 'Die Zahlungserfassung ist nicht mit dem Backend verbunden.',
  'home.assistant.paymentRegistered': 'Eine Zahlung über {sum} wurde auf Rechnung{number} erfasst.',
  'home.assistant.paymentToast': 'Zahlung erfasst',
  'home.assistant.paymentFailed': 'Die Zahlung konnte nicht erfasst werden.',
  'home.assistant.cancelled': 'In Ordnung, ich habe nichts geändert.',
  'home.assistant.sugg1': 'Wie viel schulde ich an Abgaben?',
  'home.assistant.sugg2': 'Erstelle eine Rechnung für einen Kunden',
  'home.assistant.sugg3': 'Was ist MwSt.?',
  'home.action.register_payment': 'Zahlung genehmigen',
  'home.action.create_invoice': 'Rechnungsentwurf öffnen',
  'home.action.create_other_sale': 'Sonstigen Verkauf öffnen',
  'home.action.create_expense': 'Neuen Einkauf öffnen',
  'home.action.register_purchase': 'Neuen Einkauf öffnen',
  'home.action.create_customer': 'Kunden speichern',
  'home.action.create_supplier': 'Lieferanten speichern',
  'home.action.create_product': 'Produkt speichern',
  'home.action.suggest_accounting_entry': 'Freie Buchung öffnen',
  'home.action.create_mileage_entry': 'Fahrtenbuch öffnen',
  'home.action.send_sales_document': 'Rechnungsliste öffnen',
  'home.action.book_bank_lines': 'Bank öffnen',
  'home.action.link_bank_receipts': 'Bank öffnen',
  'home.action.annul_bank_posting': 'Bank öffnen',
  'home.action.reporting_preparation': 'Meldungen öffnen',
  'home.action.default': 'Ablauf öffnen',
  'home.followup.title': 'Nachverfolgung',
  'home.followup.allClear': 'Alles unter Kontrolle',
  'home.followup.allClearSub': 'Gerade gibt es nichts nachzuverfolgen. Plumme meldet sich, wenn etwas Aufmerksamkeit braucht.',
  'home.followup.next': 'Weiter',
  'home.followup.showMore': 'Mehr anzeigen',
  'home.followup.modalTitle': 'Aufgaben, die erledigt werden müssen',
  'home.followup.sales': 'Verkauf',
  'home.followup.purchases': 'Einkauf',
  'home.followup.toInvoiceList': 'Zur Rechnungsliste',
  'home.followup.toVoucherList': 'Zur Belegliste',
  'home.followup.draftInvoices': 'Du hast {n} Rechnungsentwürfe, die nicht fertiggestellt sind.',
  'home.followup.unsentInvoices': 'Du hast {n} Rechnungen, die fertig, aber nicht gesendet sind.',
  'home.followup.overdueInvoices': 'Du hast {n} offene überfällige Rechnungen.',
  'home.followup.openPurchases': 'Du hast {n} offene Lieferantenrechnungen.',
  'home.followup.missingAttachments': 'Du hast {n} Einkäufe ohne Beleg.',
  'home.followup.bank': 'Bankabgleich',
  'home.followup.toBank': 'Zum Bankabgleich',
  'home.followup.missingBankStatements': 'Für das Geschäftskonto fehlt der Kontoauszug für {months}',
  'home.overview.sales': 'Verkauf',
  'home.overview.purchases': 'Einkauf',
  'home.overview.outstandingSales': 'Offene Verkäufe',
  'home.overview.outstandingPurchases': 'Offene Einkäufe',
  'home.overview.salesHelp': 'Offene Verkäufe sind Rechnungen, die deine Kunden noch nicht bezahlt haben. Grün ist innerhalb der Frist, Gelb ist überfällig — verfolge die überfälligen mit einer Mahnung nach.',
  'home.overview.purchasesHelp': 'Offene Einkäufe sind Lieferantenrechnungen, die du noch nicht bezahlt hast. Grün ist innerhalb der Frist, Gelb ist überfällig und sollte bald bezahlt werden.',
  'home.overview.importedSubledger': 'Davon importierte Nebenbuchhaltung: {amount}',
  'home.overview.inclVat': 'Die Beträge sind inkl. MwSt.',
  'home.overview.helpTitle': 'Offene {what}',
  'home.overview.withinDue': 'Innerhalb der Frist',
  'home.overview.overdue': 'Überfällig',
  'home.overview.statusTitle': '{within} % innerhalb der Frist · {over} % überfällig',
  'home.deadlines.title': 'Anstehende Fristen',
  'home.deadlines.help': 'Anstehende Einreichungsfristen - MVA-melding, skattemelding, Jahresabschluss und aksjonærregisteroppgave, jeweils mit Status.',
  'home.deadlines.none': 'In den Backend-Daten wurden keine Fristen gefunden.',
  'home.deadlines.seeStatus': 'Status ansehen',
  'home.deadlines.helpTax': 'Die skattemelding fasst Buchhaltung und Steuerberechnung für das Jahr zusammen. Plumme hilft dir, die Zahlen vor dem Einreichen zu prüfen.',
  'home.deadlines.helpAnnualAccounts': 'Der Jahresabschluss fasst Ergebnis, Bilanz und Anhang für das Geschäftsjahr zusammen und wird an das Regnskapsregisteret gesendet, wenn er fertig ist.',
  'home.deadlines.helpAnnualClosing': 'Die Jahresabschlussarbeiten schließen das Geschäftsjahr mit Prüfungen, Ergebnisverwendung und den nötigen Abschlussbuchungen ab.',
  'home.deadlines.helpShareholderRegister': 'Die aksjonærregisteroppgave (RF-1086) wird von Aktiengesellschaften bis zum 31. Januar des Jahres nach dem Einkommensjahr eingereicht. Plumme bietet dafür keine Einreichung — dies ist eine Erinnerung.',
  'home.deadlines.helpVat': 'Die MVA-melding meldet Umsatzsteuer und Vorsteuer für den Zeitraum.',
  'home.deadlines.helpFallback': 'Frist für {name}. Plumme benachrichtigt dich und hilft dir in der Statusansicht weiter.',
  'home.deadlines.fallbackName': 'Einreichung',
  'home.deadlines.name.shareholderRegister': 'Aksjonærregisteroppgave',
  'home.fees.title': 'Öffentliche Abgaben',
  'home.fees.help': 'Überblick darüber, was du dem Staat gerade schuldest - Mehrwertsteuer (MwSt.), Lohnsteuerabzug und Arbeitgeberabgabe. Wird laufend aus der Buchhaltung berechnet.',
  'home.fees.none': 'Keine offenen öffentlichen Abgaben gefunden.',
  'home.balances.title': 'Saldo',
  'home.balances.help': 'Gebuchter Saldo auf Bank-, Bar- und anderen Konten. Die Zahlen stammen aus der Summen- und Saldenliste und zeigen daher, was die Buchhaltung sagt - nicht, was die Bank bereits aktualisiert hat. Mit dem Zahnrad wählst du, welche Konten angezeigt werden, und kannst weitere im Kontenplan suchen. Das Geschäftskonto und die Barkasse können ausgeblendet, aber nicht entfernt werden.',
  'home.balances.choose': 'Konten wählen',
  'home.balances.total': 'Gesamt',
  'home.balances.accountFallback': 'Konto {code}',
  'home.balances.noneSelected': 'Keine Konten ausgewählt.',
  'home.balances.searchPlaceholder': 'Im Kontenplan suchen …',
  'home.balances.noHits': 'Keine Treffer',
  'home.balances.remove': 'Von der Karte entfernen',
  'home.balances.saveFailed': 'Die Kontoauswahl konnte nicht gespeichert werden.',
  'set.account': 'Konto',
  'set.amount': 'Betrag',
  'set.page': 'Seite',
  'set.debit': 'Soll',
  'set.credit': 'Haben',
  'set.remove': 'Entfernen',
  'set.ib.title': 'Eröffnungsbilanz',
  'set.ib.startWizard': 'Assistenten zum Erstellen der Eröffnungsbilanz starten',
  'set.ib.confirmDate': 'Startdatum bestätigen',
  'set.ib.setUp': 'Eröffnungsbilanz einrichten',
  'set.ib.confirmDateInPlumme': 'Startdatum in Plumme bestätigen',
  'set.ib.startDate': 'Startdatum',
  'set.back': 'Zurück',
  'set.ib.dateOk': 'Das Datum stimmt, weiter',
  'set.ib.draftEmpty': 'Der Entwurf ist leer.',
  'set.text': 'Text',
  'set.toDebit': 'An (Soll)',
  'set.fromCredit': 'Von (Haben)',
  'set.editLine': 'Zeile bearbeiten',
  'set.removeLine': 'Zeile entfernen',
  'set.quickPick': 'Schnellauswahl',
  'set.addNewLine': 'Neue Zeile hinzufügen',
  'set.saved': 'Gespeichert',
  'set.startOver': 'Neu beginnen',
  'set.ib.finish': 'Eröffnungsbilanz abschließen',
  'set.ib.summary': 'Zusammenfassung - Beträge auf und von Konten',
  'set.ib.openNote': 'Die Buchung ist offen und kann in dieser Ansicht geändert werden.',
  'set.ib.intoAccount': 'Auf Konto',
  'set.ib.outOfAccount': 'Von Konto',
  'set.sum': 'Summe',
  'set.ib.openEntry': 'Offene Buchung',
  'set.accountNo': 'Kontonr.',
  'set.name': 'Name',
  'set.vatCode': 'MwSt.-Code',
  'set.description': 'Beschreibung',
  'set.relevantLinks': 'Relevante Links',
  'set.deleteCancel': 'Löschen / stornieren',
  'set.ib.edit': 'Eröffnungsbilanz ändern',
  'set.ib.openingForAccount': 'Anfangsbestand für Konto',
  'set.cancel': 'Abbrechen',
  'set.save': 'Speichern',
  'set.ib.postDescription': 'Beschreibung des Postens',
  'set.pickAccount': 'Konto wählen ...',
  'set.accountDebit': 'Konto (Soll)',
  'set.ib.cannotBeEmpty': 'Eine leere Eröffnungsbilanz kann nicht erstellt werden',
  'set.continueTitle': 'Fortfahren?',
  'set.ib.post': 'Eröffnungsbilanz buchen',
  'set.ib.draftTitle': 'Entwurf der Eröffnungsbilanz',
  'set.ib.draftHelp': 'Gib die Bilanzzahlen aus dem vorherigen System ein, damit die Summen- und Saldenliste in Plumme richtig startet.',
  'set.noteOptional': 'Notiz (optional)',
  'set.notePh': 'Zum Beispiel, was importiert wurde und ab welchem Datum',
  'set.ib.lines': 'Bilanzzeilen',
  'set.ib.linesHelp': 'Die Bilanzzahlen zum Umstellungsdatum, aufgeteilt nach Konto: Vermögenswerte, Eigenkapital und Verbindlichkeiten aus dem alten System. Erfasse eine Zeile pro Konto, damit die Bilanz in Plumme mit den richtigen Zahlen startet.',
  'set.ib.addLine': 'Bilanzzeile hinzufügen',
  'set.startup.title': 'Startwerte',
  'set.startup.introText': 'Verwende dies, wenn du im Laufe des Jahres {year} zu Plumme wechselst. Du erfasst MwSt.- und Ergebniszahlen aus dem vorherigen System, damit Berichte und die skattemelding ab dem Umstellungsdatum korrekt fortgeführt werden.',
  'set.startup.startWizard': 'Assistenten zum Erfassen der Startwerte starten',
  'set.startup.stepDate': 'Umstellungsdatum und MwSt.',
  'set.startup.stepLines': 'Verkäufe und Kosten',
  'set.startup.confirmTitle': 'Umstellungsdatum und bisherige MwSt. bestätigen',
  'set.startup.linesTitle': 'Zahlen vor dem {date} aufteilen',
  'set.startup.save': 'Startwerte speichern',
  'set.startup.receiptTitle': 'Startwerte zum {date}',
  'set.startup.receiptSub': 'Für die Umstellung auf Plumme gespeichert',
  'set.startup.receiptLines': 'Erfasste Zeilen: {lines} - Verkäufe {sales} und Kosten {costs}.',
  'set.startup.edit': 'Startwerte ändern',
  'set.transitionDate': 'Umstellungsdatum',
  'set.transitionDateHelp': 'Das Datum, an dem du zu Plumme gewechselt bist. Die Startwerte gelten für den Zeitraum vom Jahresbeginn bis zu diesem Datum, gebucht im alten System.',
  'set.outputVatBefore': 'Umsatzsteuer vor dem Start',
  'set.outputVatBeforeHelp': 'MwSt., die du in diesem Jahr vor der Umstellung bereits auf Verkäufe erhoben hast. Sie wird zu den MwSt.-Zahlen des Jahres addiert, damit die MVA-melding stimmt.',
  'set.inputVatBefore': 'Vorsteuer vor dem Start',
  'set.inputVatBeforeHelp': 'MwSt., die du in diesem Jahr vor der Umstellung bereits auf Einkäufe gezahlt hast (und abziehen kannst).',
  'set.salesByAccount': 'Verkäufe nach Konto',
  'set.salesByAccountHelp': 'Die Umsatzerlöse des bisherigen Jahres, aufgeteilt nach Erlöskonto. Erfasse eine Zeile pro Erlöskonto, damit die Gewinn- und Verlustrechnung mit den richtigen Zahlen startet.',
  'set.salesByAccountBefore': 'Verkäufe nach Konto vor dem Start',
  'set.addSalesLine': 'Verkaufszeile hinzufügen',
  'set.noSalesLines': 'Noch keine Verkaufszeilen.',
  'set.costsByAccount': 'Kosten nach Konto',
  'set.costsByAccountHelp': 'Die Kosten des bisherigen Jahres, aufgeteilt nach Aufwandskonto. Erfasse eine Zeile pro Aufwandskonto, damit das Ergebnis ab dem Umstellungsdatum stimmt.',
  'set.costsByAccountBefore': 'Kosten nach Konto vor dem Start',
  'set.addCostLine': 'Kostenzeile hinzufügen',
  'set.noCostLines': 'Noch keine Kostenzeilen.',
  'set.import.title': 'Vollständige Buchhaltung importieren',
  'set.import.pickPackage': 'Exportdateien wählen',
  'set.import.shouldContain': 'Das Paket sollte Folgendes enthalten',
  'set.import.saft': 'SAF-T Financial XML',
  'set.import.parties': 'Kunden- und Lieferantenregister, gern als Excel oder CSV',
  'set.import.chart': 'Kontenplan',
  'set.import.vouchers': 'Belege, Quittungen und Rechnungen als PDF oder Bilder',
  'set.import.bankRecs': 'Bankabstimmungen und Rechnungskopien',
  'set.import.firstStep': 'Erster Schritt in Plumme',
  'set.import.readsStructure': 'Liest die Dateistruktur',
  'set.import.findsFiles': 'Findet SAF-T-, Excel- und Belegdateien',
  'set.import.buildsAnalysis': 'Erstellt eine Importanalyse',
  'set.import.letsApprove': 'Lässt dich den sicheren Import von Kontenplan, Kunden, Lieferanten und Eröffnungsbilanz genehmigen',
  'set.import.notAutomatic': 'Noch nicht automatisch',
  'set.import.noPromise': 'Plumme verspricht nicht, dass alles exakt mit dem vorherigen System übereinstimmt',
  'set.import.noHistoric': 'Historische Buchungen werden nicht ohne Genehmigung gebucht',
  'set.import.nothingToAltinn': 'Nichts wird an Altinn gesendet',
  'set.import.noOverwrite': 'Bestehende Belege werden nicht ohne Bestätigung gelöscht oder überschrieben',
  'set.close': 'Schließen',
  'set.import.approveBase': 'Import der Grunddaten genehmigen',
  'set.import.working': 'Wird bearbeitet...',
  'set.import.uploading': 'Hochladen in Firebase Storage',
  'set.import.serverReading': 'Der Server liest jetzt die Importdateien',
  'set.import.importingBase': 'Grunddaten werden importiert',
  'set.import.savedInAccounts': 'Der Import ist in der Buchhaltung gespeichert',
  'set.import.checkBefore': 'Prüfe Kontenplan, Kunden, Lieferanten und Eröffnungsbilanz vor der Berichterstattung.',
  'set.import.dataOnlyTitle': 'Nur Buchhaltungsdaten importieren (empfohlen)',
  'set.import.dataOnlyHelp': 'Plumme erstellt im Browser eine gefilterte Kopie mit SAF-T, CSV und Excel. PDFs, Bilder und andere Dokumente werden nicht hochgeladen.',
  'set.import.dataOnlyKeepOriginal': 'Bewahre die ursprüngliche ZIP-Datei von Fiken auf.',
  'set.import.dataOnlyFiltering': 'Dokumente werden vor dem Hochladen entfernt',
  'set.import.dataOnlyFilteringHelp': 'Die Originaldatei wird nicht verändert. Nur das neue, gefilterte Datenpaket wird an Plumme gesendet.',
  'set.import.dataOnlyFiltered': 'Vom Hochladen ausgeschlossene Dokument- und Belegdateien: {count}.',
  'set.import.dataOnlyLibraryFailed': 'Der ZIP-Filter konnte nicht geladen werden. Versuche es erneut oder entpacke SAF-T, CSV und Excel manuell.',
  'set.import.dataOnlyNoFiles': 'Im ZIP-Paket wurden keine SAF-T-, CSV- oder Excel-Dateien gefunden.',
  'set.import.packages.title': 'Gespeicherte Importpakete',
  'set.import.packages.help': 'Hier siehst du alle ZIP-Dateien und welches Paket die aktive Quelle für das Importarchiv ist.',
  'set.import.packages.loading': 'Pakete werden geladen...',
  'set.import.packages.empty': 'Keine gespeicherten ZIP-Dateien.',
  'set.import.packages.statusImported': 'Aktiver Import',
  'set.import.packages.statusDuplicate': 'Identisches Duplikat',
  'set.import.packages.statusPrevious': 'Früherer Import',
  'set.import.packages.statusAnalyzed': 'Ausgelesen',
  'set.import.packages.statusFailed': 'Auslesen fehlgeschlagen',
  'set.import.packages.statusAnalyzing': 'Wird ausgelesen',
});
